// extracted by mini-css-extract-plugin
module.exports = {"Legend":"Legend_Legend__1f-1K","LegendItems":"Legend_LegendItems__3Yr14","LegendItem":"Legend_LegendItem__29BTg","LegendIcon":"Legend_LegendIcon__130gc"};